export const publishStatusLabels: PublishStatus[] = [
  'draft',
  'published',
  'archived',
  'template',
];
